export const editMutations = <const>{
	SKLAD_PREDMETU_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'SKLAD_PREDMETU_NAKLADOVE_STREDISKO_SELECT_MAPPER',
};
